const url = new URL(window.location.href);
const reportTypeParam = url.searchParams.get('type');
export const report_type = reportTypeParam && reportTypeParam.trim() !== "" ? reportTypeParam : "0";
// 0 : report analysis
export const template_uuid = url.searchParams.get('id');
export const parent_uuid = url.searchParams.get('parent');
export const current_user = url.searchParams.get('user');
export const white_label = url.searchParams.get('hosting');
export const coord_format = url.searchParams.get('coord');
export const include_incidents = url.searchParams.get('param1');
export const incidents_radius = url.searchParams.get('param2');
export const incidents_timespan = url.searchParams.get('param3');
export let coBrandLogos = [["741af35d-8670-4969-b6ce-7533fbf2ff91", "Images/Logos/Others/hrmaritimelogo.png"],
["02E3713B-0B11-4B00-94E5-973C75A43C61", "Images/Logos/Others/agwe.png"]];
//["02E3713B-0B11-4B00-94E5-973C75A43C61", "Images/Logos/Others/nicomarsec.png"]
//["EEA4A113-4AE2-4492-A8D4-837269859233", "Images/Logos/Others/hrmaritimelogo.png"]

let host = "maritrace";
if (white_label == 1) host = "vanguard";
else if (white_label == 2) host = "sedna";
else if (white_label == 3) host = "maritime";

export let report_name = "";
if (report_type == 0) report_name = "Route Analysis";
else if (report_type == 1) report_name = "Security Report";
else if (report_type == 2) report_name = "Security Incident";
else if (report_type == 3) report_name = "Vessel Data Sheet";
else if (report_type == 4) report_name = "Vessel Timeline";

let host_name = "";
let host_logo = "";
let logo_file = "logotransparentsmall.png";
let host_url = "";

export var table_headers = ['Pos', 'Lat', 'Lon', 'Date', 'Knots', 'F/bd (m)', 'Mitigation', 'Risk', 'EEZ', 'Sea', 'JWC', 'ECA', 'Garbage', 'Noxious Liquids', 'Oil', 'Sewage'];
export var risk_index = 7;
let manifest = {
    short_name: "",
    name: "",
    icons: []
};
let folder_name = "";
if (host == "maritrace"){
    host_name = "MariTrace";
    host_url = "www.maritrace.com";
    folder_name = "Maritrace";
    manifest.name = 'MariTrace Report App';
}
else if (host == "sedna") {
    host_name = "Sedna";
    host_url = "www.sednaglobal.com";
    folder_name = "Sedna";
    manifest.name = 'Sedna Report App';
}
else if (host == "vanguard") {
    host_name = "Vanguard";
    host_url = "www.vanguard-tech.com";
    folder_name = "Vanguard";
    manifest.name = 'Vanguard Report App';
    // Vanguard's "small" asset is a square stacked lockup that collapses to a stamp at banner height;
    // their logotransparent.png is the wide variant every logo slot expects
    logo_file = "logotransparent.png";
}
else if (host == "maritime") {
    host_name = "Maritime Digital Risk";
    host_url = "www.maritimedigitalrisk.com";
    folder_name = "MDS";
    manifest.name = 'Maritime Digital Risk Report App';
}
host_logo = "Images/Logos/"+folder_name+"/"+logo_file;
manifest.icons = [
        {
          "src": "./Images/Logos/"+folder_name+"/favicon.png",
          "sizes": "67x67",
          "type": "image/png"
        },
        {
          "src": "./Images/Logos/"+folder_name+"/logotransparentsmall.png",
          "sizes": "256x58",
          "type": "image/png"
        },
        {
          "src": "./Images/Logos/"+folder_name+"/logotransparent.png",
          "sizes": "8295x1867",
          "type": "image/png"
        }
      ];
manifest.short_name = host_name;

let mani_url = "data:application/manifest+json,"+encodeURIComponent(JSON.stringify(manifest));
let element = document.createElement('link');
element.setAttribute('rel', 'manifest');
element.setAttribute('href', mani_url);
document.querySelector('head').appendChild(element);

export { host_name };
export { host_logo };
export { host_url };

export let user_details : MariTraceUserAccount = {
  user_account_uuid: '',
  maritrace_parent_account: null,
  email: '',
  first_name: '',
  last_name: '',
  expires: ''
};
export let user_parent : MariTraceParentAccount = {
  parent_account_uuid: '',
  parent_account_name: '',
  tracking_slots: 0
};

export const parentAccount = {
  parent_account_uuid: '',
  parent_account_name: '',
  tracking_slots: 0
};
export const getParentAccount = () => parentAccount ;
export const userAccount = {
  user_account_uuid: '',
  maritrace_parent_account: parentAccount,
  email: '',
  first_name: '',
  last_name: '',
  expires: '',
  ffid: ''
};
export const getUserAccount = () => userAccount ;

export const updateAccountDetails = (keyOrObject, value, isParent = false) => {
  if (typeof keyOrObject === 'object' && keyOrObject !== null) {
    Object.keys(keyOrObject).forEach((key) => {
      if(isParent && key in parentAccount) parentAccount[key] = keyOrObject[key];
      if (!isParent && key in userAccount) userAccount[key] = keyOrObject[key];
      else console.warn(`Key "${key}" does not exist in Account state.`);
    });
  } else if (isParent && typeof keyOrObject === 'string' && keyOrObject in parentAccount) {
        parentAccount[keyOrObject] = value;
  } else if (!isParent && typeof keyOrObject === 'string' && keyOrObject in userAccount) {
    userAccount[keyOrObject] = value;
  } else console.warn(`Invalid key or object: ${keyOrObject}`);
};

export interface Country {
  name: string;
  alpha_2_code: string;
  alpha_3_code: string;
  numeric_code: string;
  region: string;
  continent: string;
}
export function formatCountry(country_data) {
    return{
        name: country_data.name,
        alpha_2_code: country_data.alpha_2_code,
        alpha_3_code: country_data.alpha_3_code,
        numeric_code: country_data.numeric_code,
        region: country_data.region,
        continent: country_data.continent,
    }
}

export interface Vessel {
    vessel_identifier: string;
    name: string;
    imo: string;
    mmsi: string;
    callsign: string;
    flag: Country | null;
    ais_type: string;
    type: string;
    sub_type: string;
    dwt?: number;
    length?: number;
    breadth?: number;
    commercial_owner: string;
    effective_controller: string;
    technical_manager: string;
    financial_owner: string;
    gt?: number;
}
export function formatVessel(vessel_data) {
    return {
           vessel_identifier: vessel_data.vessel_identifier,
           name: vessel_data.name,
           imo: vessel_data.imo,
           mmsi: vessel_data.mmsi,
           callsign: vessel_data.callsign,
           flag: vessel_data.flag ? formatCountry(vessel_data.flag) : null,
           ais_type: vessel_data.ais_type,
           type: vessel_data.type,
           sub_type: vessel_data.sub_type,
           dwt: vessel_data.dwt,
           length: vessel_data.length,
           breadth: vessel_data.breadth,
           commercial_owner: vessel_data.commercial_owner,
           effective_controller: vessel_data.effective_controller,
           technical_manager: vessel_data.technical_manager,
           financial_owner: vessel_data.financial_owner,
           gt: vessel_data.gt,
    }
}

export type MariTraceParentAccount = {
    parent_account_uuid: string;
    parent_account_name: string;
    tracking_slots: number;
}
export type MariTraceUserAccount = {
    user_account_uuid: string;
    maritrace_parent_account: MariTraceParentAccount | null;
    email: string;
    first_name: string;
    last_name: string;
    expires: string;
}

export function formatUserAccount(user_data) {
  return {
    user_account_uuid: user_data.user_account_uuid,
    maritrace_parent_account: user_data.maritrace_parent_account ? formatUsersParent(user_data.maritrace_parent_account) : null,
    email: user_data.email,
    first_name: user_data.first_name,
    last_name: user_data.last_name,
    expires: user_data.expires,
  };
}
export function formatUsersParent(user_data) {
  return {
    parent_account_uuid: user_data.parent_account_uuid,
    parent_account_name: user_data.parent_account_name,
    tracking_slots: user_data.tracking_slots,
  }
}

export interface RecordInformation {
    created_by_user: MariTraceUserAccount | null;
    created_date: Date | null;
    deleted_by_user: MariTraceUserAccount | null;
    deleted_date?: Date | null;
    edited_by_user: MariTraceUserAccount | null;
    edited_date?: Date | null;
    parent_account: MariTraceParentAccount | null;
}
export interface RouteTemplate extends RecordInformation {
    route_template_uuid: string;
    name: string;
    group_name: string;
    vessel?: Vessel | null;
    etd?: Date | null;
    geojson_text: string;
}

export function formatRouteTemplate(route_data){
    return {
        route_template_uuid: route_data.route_template_uuid,
        name: route_data.name,
        group_name: route_data.group_name,
        vessel: route_data.vessel ? formatVessel(route_data.vessel): null,
        etd: route_data.etd ? new Date(route_data.etd) : null,
        geojson_text: route_data.geojson_text,
        created_by_user: route_data.created_by_user ? formatUserAccount(route_data.created_by_user) : null,
        created_date: new Date(route_data.created_date),
        deleted_by_user: route_data.deleted_by_user ? formatUserAccount(route_data.deleted_by_user) : null,
        deleted_date: route_data.deleted_date ? new Date(route_data.deleted_date) : null,
        edited_by_user: route_data.edited_by_user ? formatUserAccount(route_data.edited_by_user) : null,
        edited_date: route_data.edited_date ? new Date(route_data.edited_date) : null,
        parent_account: route_data.parent_account ? formatUsersParent(route_data.parent_account) : null,
    }
}

interface Speed {
  knots: number;
  kph: number;
  mph: number;
  ms: number;
}
interface Coordinates {
  lat: number;
  lon: number;
}
interface Properties {
  waypoint_number: number;
  waypoint_name: string;
  speed: Speed;
  in_port: boolean;
  wait_time_hours: number;
  freeboard_metres: number;
  mitigation: number | string;
}
interface Geometry {
  type: string;
  coordinates: number[];
}
interface Feature {
  type: string;
  geometry: Geometry;
  properties: Properties;
}
function formatFeature(inputData){
    return  {
        type: inputData.type,
        geometry: {
          type: inputData.geometry.type,
          coordinates: {
            lat: inputData.geometry.coordinates.lat,
            lon: inputData.geometry.coordinates.lon,
          }
        },
        properties: {
          waypoint_number: inputData.properties.waypoint_number,
          waypoint_name: inputData.properties.waypoint_name,
          speed: {
            Knots: inputData.properties.speed.Knots,
            Kph: inputData.properties.speed.Kph,
            Mph: inputData.properties.speed.Mph,
            Ms: inputData.properties.speed.Ms,
          },
          in_port: inputData.properties.in_port,
          wait_time_hours: inputData.properties.wait_time_hours,
          freeboard_metres: inputData.properties.freeboard_metres,
          mitigation: inputData.properties.mitigation,
        },
    };
}
interface Metadata {
  schema_provider: string;
  schema_type: string;
  schema_version: string;
}
export interface FeatureCollection {
  type: string;
  metadata: Metadata;
  features: Feature[];
}
export function formatFeatureCollection(inputData){
  return {
    type: inputData.type,
    metadata: {
      schema_provider: inputData.metadata.schema_provider,
      schema_type: inputData.metadata.schema_type,
      schema_version: inputData.metadata.schema_version,
    },
    features: inputData.features ? inputData.features.map(feature => formatFeature(feature)) : [],
  };
}

export interface Location {
  id: string | null;
  dec: Coordinates;
  Ddm: {
    LatDeg: number;
    LatMin: number;
    LatDir: number;
    LatString: string;
    LonDeg: number;
    LonMin: number;
    LonDir: number;
    LonString: string;
  } | null;
  Dms: {
    LatDeg: number;
    LatMin: number;
    LatSec: number;
    LatDir: number;
    LatString: string;
    LonDeg: number;
    LonMin: number;
    LonSec: number;
    LonDir: number;
    LonString: string;
  } | null;
}
interface Waypoint {
  position_number: number;
  waypoint_number: number;
  waiting: boolean;
  speed: Speed;
  freeboard: number;
  in_port: boolean;
  date_reached: string;
  position_location: Location;
  next_location: Location;
  mitigations: string;
  distance_from_last: {
    kilometers: number;
    Metres: number;
    NauticalMiles: number;
    StatuteMiles: number;
  };
  distance_overall: {
    kilometers: number;
    Metres: number;
    NauticalMiles: number;
    StatuteMiles: number;
  };
  overall_threat: number;
  suspicious_percentage: number;
  approached_percentage: number;
  fired_upon_percentage: number;
  hijacking_kidnapping_percentage: number;
  boarded_percentage: number;
  robbed_percentage: number;
  risk_number: number;
  risk_string: string;
  risk_colour_hex: string;
  eez_name: string;
  sea_name: string;
  jwc_name: string;
  marpol_eca: boolean;
  marpol_garbage: boolean;
  marpol_noxious_liquid: boolean;
  marpol_oil: boolean;
  marpol_sewage: boolean;
}
function formatWaypoint(waypoint: any): Waypoint {
  return {
    position_number: waypoint.position_number,
    waypoint_number: waypoint.waypoint_number,
    waiting: waypoint.waiting,
    speed: waypoint.speed,
    freeboard: waypoint.freeboard,
    in_port: waypoint.in_port,
    date_reached: waypoint.date_reached,
    position_location: waypoint.position_location,
    next_location: waypoint.next_location,
    mitigations: waypoint.mitigations,
    distance_from_last: waypoint.distance_from_last,
    distance_overall: waypoint.distance_overall,
    overall_threat: waypoint.overall_threat,
    suspicious_percentage: waypoint.suspicious_percentage,
    approached_percentage: waypoint.approached_percentage,
    fired_upon_percentage: waypoint.fired_upon_percentage,
    hijacking_kidnapping_percentage: waypoint.hijacking_kidnapping_percentage,
    boarded_percentage: waypoint.boarded_percentage,
    robbed_percentage: waypoint.robbed_percentage,
    risk_number: waypoint.risk_number,
    risk_string: waypoint.risk_string,
    risk_colour_hex: waypoint.risk_colour_hex,
    eez_name: waypoint.eez_name,
    sea_name: waypoint.sea_name,
    jwc_name: waypoint.jwc_name,
    marpol_eca: waypoint.marpol_eca,
    marpol_garbage: waypoint.marpol_garbage,
    marpol_noxious_liquid: waypoint.marpol_noxious_liquid,
    marpol_oil: waypoint.marpol_oil,
    marpol_sewage: waypoint.marpol_sewage,
  };
}

interface Route {
  type: string;
  metadata: Metadata;
  features: Array<{
    type: string;
    geometry: Geometry;
    properties: Waypoint;
  }>;
}
export interface AnalysedRoute {
  eta: string;
  etd: string;
  max_freeboard: number;
  max_risk: number;
  max_risk_string: string;
  max_risk_color: string;
  max_risk_text_color: string;
  max_speed: Speed;
  min_freeboard: number;
  min_speed: Speed;
  mitigations: string[];
  parameters: {
    route: Route;
  };
  route_name: string;
  coordinate_format: string;
  vessel_uuid: string | null;
  vessel_name: string;
  vessel_type_group: number;
  return_risk: boolean;
  return_geography: boolean;
  user: MariTraceUserAccount;
  parent: MariTraceParentAccount;
  email_address: string;
  total_distance: {
    kilometers: number;
    metres: number;
    nauticalMiles: number;
    statuteMiles: number;
  };
  total_hours: number;
  vessel: Vessel | null;
  waypoints: Waypoint[];
}

export function formatAnalysedRoute(inputData: any){//}: MainData {
  return {
    eta: inputData.eta,
    etd: inputData.etd,
    max_freeboard: inputData.max_freeboard,
    max_risk: inputData.max_risk,
    //max_risk_string: string;
    //max_risk_color: string;
    max_speed: inputData.max_speed,
    min_freeboard: inputData.min_freeboard,
    min_speed: inputData.min_speed,
    mitigations: inputData.mitigations,
    parameters: {
      route: {
        type: inputData.parameters.route.type,
        metadata: {
          schema_provider: inputData.parameters.route.metadata.schema_provider,
          schema_type: inputData.parameters.route.metadata.schema_type,
          schema_version: inputData.parameters.route.metadata.schema_version,
        },
        features: inputData.parameters.route.features ? inputData.parameters.route.features.map(feature => formatFeature(feature)) : [],
      },
    },
    route_name: inputData.route_name,
    coordinate_format: inputData.coordinate_format,
    vessel_uuid: inputData.vessel_uuid,
    vessel_name: inputData.vessel_name,
    vessel_type_group: inputData.vessel_type_group,
    return_risk: inputData.return_risk,
    return_geography: inputData.return_geography,
    user: inputData.user,
    parent: inputData.parent,
    email_address: inputData.email_address,
    total_distance: inputData.total_distance,
    total_hours: inputData.total_hours,
    vessel: inputData.vessel ? formatVessel(inputData.vessel): null,
    waypoints: inputData.waypoints.map((waypoint: any) => formatWaypoint(waypoint)),
  };
}

export interface Incidents_requestParameters{
    start_date : string;
    end_date : string;
    distance : number;
    measurement : string;
    search_route : Incidents_route[];
}

interface Incidents_route{
    date_reached: string;
    lat: number;
    lon: number;
}
interface hours_item_details {
    name: string;
    date: string;
}
interface hours_item {
    name: string;
    info: hours_item_details[];
}
export interface report_info {
    transit: string;
    vessel: string;
    route: [];
    risk: {
        risks: [];
        incidents_types: [];
        incident_likelihood: [];
    };
    speed_freeboard: [];
    hours_in: hours_item[];
}

export interface RouteIncident {
    row: number;
    external_ref: string;
    incident_status: string;
    weapon_other: string;
    incident_weapons: string;
    dimension: string;
    incident_crime_at_sea_uuid: string;
    status_approached: bool;
    status_boarded: bool;
    status_fired_upon: bool;
    status_hijacked: bool;
    status_kidnapped: bool;
    status_robbed: bool;
    status_suspicious: bool;
    status_unknown: bool;
    weapon_blade: bool;
    weapon_guns: bool;
    weapon_no: bool;
    weapon_rpg: bool;
    weapon_unknown: bool;
    weapon_unknown_armed: bool;
    local_date_time: string;
    utc_date_time: string;
    incident_coordinates: Location,
    victim_vessel_beam: number;
    victim_vessel_length_overall: number;
    victim_vessel_gross_tonnage: number;
    attacker_count: number;
    narration: string;
    sea: string;
    pirate_vessel_description: string;
    time_of_day: string;
    victim_vessel_flag:{
        name: string;
        alpha_2_code: string;
        alpha_3_code: string;
        numeric_code: string;
        region: string;
        continent: string;
    },
    victim_vessel_imo: number;
    victim_vessel_mmsi: number;
    victim_vessel_name: string;
    victim_vessel_status: string;
    victim_vessel_type: string;
    source: string;

}
export function formatRouteIncident(inputData: any) {
    return {
        row: inputData.row || 0,  // Default to 0 if row is falsy
        external_ref: inputData.external_ref || "",  // Default to empty string if not available
        incident_status: inputData.incident_status || "",  // Default to empty string if not available
        weapon_other: inputData.weapon_other || "",  // Default to empty string if not available
        incident_weapons: inputData.incident_weapons || "",  // Default to empty string if not available
        dimension: inputData.dimension || "",  // Default to empty string if not available
        incident_crime_at_sea_uuid: inputData.incident_crime_at_sea_uuid || "",  // Default to empty string if not available
        status_approached: inputData.status_approached || false,  // Default to false if not available
        status_boarded: inputData.status_boarded || false,  // Default to false if not available
        status_fired_upon: inputData.status_fired_upon || false,  // Default to false if not available
        status_hijacked: inputData.status_hijacked || false,  // Default to false if not available
        status_kidnapped: inputData.status_kidnapped || false,  // Default to false if not available
        status_robbed: inputData.status_robbed || false,  // Default to false if not available
        status_suspicious: inputData.status_suspicious || false,  // Default to false if not available
        status_unknown: inputData.status_unknown || false,  // Default to false if not available
        weapon_blade: inputData.weapon_blade || 0,  // Default to 0 if not available
        weapon_guns: inputData.weapon_guns || 0,  // Default to 0 if not available
        weapon_no: inputData.weapon_no || 0,  // Default to 0 if not available
        weapon_rpg: inputData.weapon_rpg || 0,  // Default to 0 if not available
        weapon_unknown: inputData.weapon_unknown || 0,  // Default to 0 if not available
        weapon_unknown_armed: inputData.weapon_unknown_armed || 0,  // Default to 0 if not available
        local_date_time: inputData.local_date_time || "",  // Default to empty string if not available
        utc_date_time: inputData.utc_date_time || "",  // Default to empty string if not available
        incident_coordinates: inputData.incident_coordinates || "",  // Default to empty string if not available
        victim_vessel_beam: inputData.victim_vessel_beam || 0,  // Default to 0 if not available
        victim_vessel_length_overall: inputData.victim_vessel_length_overall || 0,  // Default to 0 if not available
        victim_vessel_gross_tonnage: inputData.victim_vessel_gross_tonnage || 0,  // Default to 0 if not available
        attacker_count: inputData.attacker_count || 0,  // Default to 0 if not available
        narration: inputData.narration || "",  // Default to empty string if not available
        sea: inputData.sea || "",  // Default to empty string if not available
        pirate_vessel_description: inputData.pirate_vessel_description || "",  // Default to empty string if not available
        time_of_day: inputData.time_of_day || "",  // Default to empty string if not available
        victim_vessel_flag: inputData.victim_vessel_flag || "",  // Default to empty string if not available
        victim_vessel_imo: inputData.victim_vessel_imo || "",  // Default to empty string if not available
        victim_vessel_mmsi: inputData.victim_vessel_mmsi || "",  // Default to empty string if not available
        victim_vessel_name: inputData.victim_vessel_name || "",  // Default to empty string if not available
        victim_vessel_status: inputData.victim_vessel_status || "",  // Default to empty string if not available
        victim_vessel_type: inputData.victim_vessel_type || "",  // Default to empty string if not available
        source: inputData.source || ""
    };
}

export function formatRouteIncident_optimised(inputData: any) {
	return formatRouteIncident({
		row: inputData.row,
		external_ref: "",
		incident_status: inputData.incident_status,
		weapon_other: "",
		incident_weapons: inputData.incident_weapons,
		dimension: inputData.dimension,
		incident_crime_at_sea_uuid: "",
		status_approached: false,
		status_boarded: false,
		status_fired_upon: false,
		status_hijacked: false,
		status_kidnapped: false,
		status_robbed: false,
		status_suspicious: false,
		status_unknown: false,
		weapon_blade: false,
		weapon_guns: false,
		weapon_no: false,
		weapon_rpg: false,
		weapon_unknown: false,
		weapon_unknown_armed: false,
		local_date_time: inputData.local_date_time,
		utc_date_time: inputData.utc_date_time,
		incident_coordinates: inputData.incident_coordinates,
		victim_vessel_beam: 0,
		victim_vessel_length_overall: 0,
		victim_vessel_gross_tonnage: inputData.victim_vessel_gross_tonnage,
		attacker_count: inputData.attacker_count,
		narration: inputData.narration,
		sea: inputData.sea,
		pirate_vessel_description: inputData.pirate_vessel_description,
		time_of_day: inputData.time_of_day,
		victim_vessel_flag: inputData.victim_vessel_flag || { name: "" },
		victim_vessel_imo: inputData.victim_vessel_imo,
		victim_vessel_mmsi: inputData.victim_vessel_mmsi,
		victim_vessel_name: inputData.victim_vessel_name,
		victim_vessel_status: inputData.victim_vessel_status,
		victim_vessel_type: inputData.victim_vessel_type,
		source: ""
	});
}


interface ZonePlotData {
  data: any;
  layout: any;
}

export interface AllZonePlots {
  plot_name: string;
  plot_data: ZonePlotData;
}

export const line_plot_colours = ["#4d80bc", "#a64543"];
export const incident_plot_colours = {
    suspicious_percentage: ["Suspicious", "#5b9cd5"],
    approached_percentage: ["Approached", "#7f7f7f"],
    boarded_percentage: ["Boarded", "#fffd02"],
    robbed_percentage: ["Robbed", "#edb31f"],
    fired_upon_percentage: ["Fired-upon", "#00000"],
    hijacking_kidnapping_percentage: ["Hijacked/Kidnapping", "#e8051f"],
}

export const color_palette2 = [
"#67b344",
"#c5489b",
"#a45ccf",
"#b9b345",
"#5f74da",
"#d28e47",
"#5e98d2",
"#ce5335",
"#3fbfbc",
"#d5456b",
"#60bc82",
"#7a5c9d",
"#467e45",
"#d089c5",
"#827731",
"#b56262"]

export const color_palette = [
"#1f77b4",
"#ff7f0e",
"#2ca02c",
"#d62728",
"#9467bd",
"#8c564b",
"#e377c2",
"#7f7f7f",
"#bcbd22",
"#17becf",
"#aec7e8",
"#ffbb78",
"#98df8a",
"#ff9896",
"#c5b0d5",
"#c49c94",
"#f7b6d2",
"#c7c7c7",
"#dbdb8d",
"#9edae5"];

export const color_mappings = {
    "LOW": ["#00FF00", [0, 0, 0]], // Green
    "MEDIUM-LOW": ["#80FF00", [0, 0, 0]], // Between green and yellow
    "MEDIUM": ["#FFFF00", [0, 0, 0]], // Yellow
    "MEDIUM-HIGH": ["#FFA500", [0, 0, 0]], // Orange
    "HIGH": ["#FF0000", [255, 255, 255]], // Red
    "VERY-HIGH": ["#8B0000", [255, 255, 255]], // Dark Red
    "EXTREME": ["#800000", [255, 255, 255]] // Maroon
};

export type ReportPageParameters = {
  report_page_parameters_uuid: string;
  report_data_id: string;
  report_name: string;
  user_uuid: string | null;
  whitelabelling: string;
  incident_uuid: string | null;
  incident_latitude: number | null;
  incident_longitude: number | null;
  incident_logo: string;
  multi_incident_date_from: string;
  multi_incident_date_to: string;
  multi_incident_areas: string;
  multi_incident_vessel_types: string;
  multi_incident_incident_types: string;
  multi_incident_time_of_day: string;
  multi_incident_vessel_status: string;
  multi_incident_weapons: string;
  vessel_event_uuid_1: string | null;
  vessel_event_uuid_2: string | null;
  tracked_vessel_uuid: string | null;
  risk_assessment_name: string;
  risk_assessment_vessel_name: string;
  risk_assessment_imo: string;
  risk_assessment_mmsi: string;
  risk_assessment_etd: string | null;
  risk_assessment_eta: string | null;
  risk_assessment_hours: number | null;
  risk_assessment_distance: number | null;
  risk_assessment_max_speed: number | null;
  risk_assessment_min_speed: number | null;
  risk_assessment_max_freeboard: number | null;
  risk_assessment_min_freeboard: number | null;
  risk_assessment_highest_risk: number | null;
  risk_assessment_mitigations_list: string;
  risk_assessment_callsign: string;
  risk_assessment_vessel_type: string;
  risk_assessment_accreditation: string;
  white_label_parent_uuid: string | null;
  route_analysis_include_security: string;
  route_analysis_radius: number | null;
  route_analysis_months: number | null;
};
export function formatReportPageParameters(data: any): ReportPageParameters {
  return {
    report_page_parameters_uuid: data.report_page_parameters_uuid,
    report_data_id: data.report_data_id,
    report_name: data.report_name || '',
    user_uuid: data.user_uuid || null,
    whitelabelling: data.whitelabelling || '',
    incident_uuid: data.incident_uuid || null,
    incident_latitude: data.incident_latitude || null,
    incident_longitude: data.incident_longitude || null,
    incident_logo: data.incident_logo || '',
    multi_incident_date_from: data.multi_incident_date_from || '',
    multi_incident_date_to: data.multi_incident_date_to || '',
    multi_incident_areas: data.multi_incident_areas || '',
    multi_incident_vessel_types: data.multi_incident_vessel_types || '',
    multi_incident_incident_types: data.multi_incident_incident_types || '',
    multi_incident_time_of_day: data.multi_incident_time_of_day || '',
    multi_incident_vessel_status: data.multi_incident_vessel_status || '',
    multi_incident_weapons: data.multi_incident_weapons || '',
    vessel_event_uuid_1: data.vessel_event_uuid_1 || null,
    vessel_event_uuid_2: data.vessel_event_uuid_2 || null,
    tracked_vessel_uuid: data.tracked_vessel_uuid || null,
    risk_assessment_name: data.risk_assessment_name || '',
    risk_assessment_vessel_name: data.risk_assessment_vessel_name || '',
    risk_assessment_imo: data.risk_assessment_imo || '',
    risk_assessment_mmsi: data.risk_assessment_mmsi || '',
    risk_assessment_etd: data.risk_assessment_etd ? new Date(data.risk_assessment_etd).toISOString() : null,
    risk_assessment_eta: data.risk_assessment_eta ? new Date(data.risk_assessment_eta).toISOString() : null,
    risk_assessment_hours: data.risk_assessment_hours || null,
    risk_assessment_distance: data.risk_assessment_distance || null,
    risk_assessment_max_speed: data.risk_assessment_max_speed || null,
    risk_assessment_min_speed: data.risk_assessment_min_speed || null,
    risk_assessment_max_freeboard: data.risk_assessment_max_freeboard || null,
    risk_assessment_min_freeboard: data.risk_assessment_min_freeboard || null,
    risk_assessment_highest_risk: data.risk_assessment_highest_risk || null,
    risk_assessment_mitigations_list: data.risk_assessment_mitigations_list || '',
    risk_assessment_callsign: data.risk_assessment_callsign || '',
    risk_assessment_vessel_type: data.risk_assessment_vessel_type || '',
    risk_assessment_accreditation: data.risk_assessment_accreditation || '',
    white_label_parent_uuid: data.white_label_parent_uuid || null,
    route_analysis_include_security: data.route_analysis_include_security || '',
    route_analysis_radius: data.route_analysis_radius || null,
    route_analysis_months: data.route_analysis_months || null,
  };
}

export interface VesselDetailed {
    imo: string;
    mmsi: string;
    callsign: string;
    vessel_ais_name: string;
    vessel_name: string;
    flag: Flag;
    vessel_type_name: string;
    vessel_type_code: string;
    ais_vessel_type_simple: string;
    built_year: number | null;
    dimensions: VesselDimensions;
    tanker_trade_name: string;
    tanker_trade_code: string;
    datetime: Date | null;
    ais_navigation_status_text: string;
    speed: Speed;
    course: number | null;
    true_heading: number | null;
    ais_destination: string;
    destination_port_name: string;
    destination_port_uuid: string;
    destination_country_name: string;
    ais_eta: string;
    decoded_eta: string;
    draught: number | null;
    source: string;
    user_destination_port: string;
    user_destination_port_uuid: string;
    user_destination_country: string;
    user_destination_locode: string;
    coordinate: Location;
    company: Company;
    mercury: VesselMercury;
    value: VesselValue;
}

export interface CompanyInfo {
    uuid: string;
    short_name: string;
    long_name: string;
    company_type: string;
    country_code: string;
    country_name: string;
    website?: string;
    parent?: ParentCompanyInfo | null;
    root?: ParentCompanyInfo | null;
}

interface ParentCompanyInfo {
    uuid: string | null;
    short_name: string | null;
    long_name: string | null;
    company_type: string | null;
    country_code: string | null;
    country_name: string | null;
    website: string | null;
}

interface Company {
    owner?: CompanyInfo;
    controller?: CompanyInfo;
    technical_manager?: CompanyInfo;
    financial_owner?: CompanyInfo | null;
}

interface VesselDimensions {
    loa: number | null;
    beam: number | null;
    dimension_to_bow: number | null;
    dimension_to_stern: number | null;
    dimension_to_port: number | null;
    dimension_to_starboard: number | null;
    liquid_cubic_98_percent: number | null;
    maximum_draught: number | null;
    bale_cubic: string;
    grain_cubic: string;
    ldt: string;
    max_teus: string;
    gross_tonnage: number | null;
    net_tonnage: number | null;
    dwt: number | null;
}

interface VesselMercury{
    mercury_box_id: string;
    mercury_time: Date | null;
    mercury_coordinate: Location;
    mercury_velocity: Speed | null;
    mercury_dir: string;
}

interface VesselValue{
    hull: string;
    iv: string;
    loss_of_hire: string;
    calculated_total: string;
}

interface Flag{
    flag_image: string;
    flag_url: string;
    flag_name: string;
    flag_alpha_2_code: string;
}

export function formatVesselDetails(data: any): VesselDetailed {
  return {
    imo: data.imo || '',
    mmsi: data.mmsi || '',
    callsign: data.callsign || '',
    vessel_ais_name: data.vessel_ais_name || '',
    vessel_name: data.vessel_name || '',
    flag: {
        flag_image: data.flag_image || '',
        flag_url: data.flag_url || '',
        flag_name: data.flag_name || '',
        flag_alpha_2_code: data.flag_alpha_2_code || '',
    },
    vessel_type_name: data.vessel_type_name || '',
    vessel_type_code: data.vessel_type_code || '',
    ais_vessel_type_simple: data.ais_vessel_type_simple || '',
    built_year: data.built_year || null,
    dimensions: {
        loa: data.loa || null,
        beam: data.beam || null,
        dimension_to_bow: data.dimension_to_bow || null,
        dimension_to_stern: data.dimension_to_stern || null,
        dimension_to_port: data.dimension_to_port || null,
        dimension_to_starboard: data.dimension_to_starboard || null,
        maximum_draught: data.maximum_draught || null,
        gross_tonnage: data.gross_tonnage || null,
        net_tonnage: data.net_tonnage ?? null,
        liquid_cubic_98_percent: data.liquid_cubic_98_percent || null,
        bale_cubic: data.bale_cubic || 'UNKNOWN',
        grain_cubic: data.grain_cubic || 'UNKNOWN',
        ldt: data.ldt || 'UNKNOWN',
        max_teus: data.max_teus || 'UNKNOWN',
        dwt: data.dwt || null,

    },
    tanker_trade_name: data.tanker_trade_name || '',
    tanker_trade_code: data.tanker_trade_code || '',
    datetime: data.datetime || null,
    ais_navigation_status_text: data.ais_navigation_status_text || '',
    course: data.course || null,
    true_heading: data.true_heading || null,
    ais_destination: data.ais_destination || '',
    destination_port_name: data.destination_port_name || '',
    destination_country_name: data.destination_country_name || '',
    ais_eta: data.ais_eta || '',
    decoded_eta: data.decoded_eta || '',
    draught: data.draught || null,
    source: data.source || '',
    user_destination_port: data.user_destination_port || '',
    user_destination_port_uuid: data.user_destination_port_uuide || '',
    user_destination_country: data.user_destination_country || '',
    user_destination_locode: data.user_destination_locode || '',
    coordinate: {
      dec: {
        lat: data.coordinate?.dec?.lat || null,
        lon: data.coordinate?.dec?.lon || null,
      },
      Ddm: data.coordinate?.Ddm || null,
      Dms: data.coordinate?.Dms || null,
    },
    company: {
        owner: formatCompanyInfo(data, 'company_owner'),
        controller: formatCompanyInfo(data, 'company_controller'),
        technical_manager: formatCompanyInfo(data, 'technical_manager'),
        financial_owner: formatCompanyInfo(data, 'financial_owner'),
    },
    speed: data.speed || {
      Knots: null,
      Kph: null,
      Mph: null,
      Ms: null,
    },
    mercury: {
        mercury_box_id: data.mercury_box_id || '',
        mercury_time: data.mercury_time || null,
        mercury_coordinate: {
            dec: {
                lat: data.coordinate?.dec?.lat || null,
                lon: data.coordinate?.dec?.lon || null,
            },
            Ddm: data.coordinate?.Ddm || null,
            Dms: data.coordinate?.Dms || null,
        },
        mercury_velocity: data.mercury_velocity || {
             knots: null,
             kph: null,
             mph: null,
             ms: null,
           },
        mercury_dir: data.mercury_dir || '',
    },
    value: {
        hull: data.hull || '',
        iv: data.iv || '',
        loss_of_hire: data.loss_of_hire || '',
        calculated_total: data.calculated_total || '',
    },
  };
}
function formatCompanyInfo(data: any, prefix: string): CompanyInfo | null {
  if (!data[`${prefix}_uuid`]) return null;

  return {
    uuid: data[`${prefix}_uuid`] || '',
    short_name: data[`${prefix}_short_name`] || '',
    long_name: data[`${prefix}_long_name`] || '',
    company_type: data[`${prefix}_company_type_text`] || '',
    country_code: data[`${prefix}_alpha_2_code`] || '',
    country_name: data[`${prefix}_country_name`] || '',
    website: data[`${prefix}_website`] || null,
    parent: formatParentCompanyInfo(data, `${prefix}_parent`),
    root: formatParentCompanyInfo(data, `${prefix}_root`),
  };
}

function formatParentCompanyInfo(data: any, prefix: string): ParentCompanyInfo | null {
  if (!data[`${prefix}_uuid`]) return null;

  return {
    uuid: data[`${prefix}_uuid`] || null,
    short_name: data[`${prefix}_short_name`] || null,
    long_name: data[`${prefix}_long_name`] || null,
    company_type: data[`${prefix}_company_type_text`] || null,
    country_code: data[`${prefix}_alpha_2_code`] || null,
    country_name: data[`${prefix}_country_name`] || null,
    website: data[`${prefix}_website`] || null,
  };
}

export interface PositionReport {
  vessel_uuid: string;
  vessel_id: string;
  vessel_name: string;
  destination: string;
  mmsi: string;
  imo_number: string;
  callsign: string;
  ship_type: number;
  navigation_status: number;
  dimension_to_bow: number;
  dimension_to_port: number;
  dimension_to_starboard: number;
  dimension_to_stern: number;
  draught: number;
  eta_month: string;
  eta_day: string;
  eta_hour: string;
  eta_minute: string;
  longitude: number;
  latitude: number;
  geojson: string;
  date_received: string;
  speed_over_ground: number;
  course_over_ground: number;
  true_heading: number;
  rate_of_turn: number;
  source: string;
  //local
  row: number | null;
  //others
  load: string;
  commodity: string;
}

export function formatPositionReport(data: any): PositionReport | null {
  if (!data || !data.vessel_uuid) return null;

  return {
    vessel_uuid: data.vessel_uuid || "",
    vessel_id: data.vessel_id || "",
    vessel_name: data.vessel_name || "",
    destination: data.destination || "",
    mmsi: data.mmsi || "",
    imo_number: data.imo_number || "",
    callsign: data.callsign || "",
    ship_type: Number(data.ship_type) || 0,
    navigation_status: Number(data.navigation_status) || 0,
    dimension_to_bow: Number(data.dimension_to_bow) || 0,
    dimension_to_port: Number(data.dimension_to_port) || 0,
    dimension_to_starboard: Number(data.dimension_to_starboard) || 0,
    dimension_to_stern: Number(data.dimension_to_stern) || 0,
    draught: Number(data.draught) || 0,
    eta_month: data.eta_month || "",
    eta_day: data.eta_day || "",
    eta_hour: data.eta_hour || "",
    eta_minute: data.eta_minute || "",
    latitude: Number(data.latitude) || 0,
    longitude: Number(data.longitude) || 0,
    geojson: data.geojson || "",
    date_received: data.date_received || "",
    speed_over_ground: Number(data.speed_over_ground) || 0,
    course_over_ground: Number(data.course_over_ground) || 0,
    true_heading: Number(data.true_heading) || 0,
    rate_of_turn: Number(data.rate_of_turn) || 0,
    source: data.source || "",
    row: data.row || null,
  };
}


export interface SpacialArea {
  berth_name: string;
  berthing_area_name: string;
  eez: string;
  houthi_area: boolean;
  jwc_zone: string;
  marpol_eca: string;
  marpol_garbage: string;
  marpol_noxious_liquid: string;
  marpol_oil: string;
  marpol_sewage: string;
  portName: string | null;
  port_name: string;
  position: Location;
  position_id: string;
  sea_zone: string;
}

export function formatSpacialArea(data: any): SpacialArea {
  return {
    berth_name: data.berth_name || "",
    berthing_area_name: data.berthing_area_name || "",
    eez: data.eez || "",
    houthi_area: Boolean(data.houthi_area),
    jwc_zone: data.jwc_zone || "",
    marpol_eca: data.marpol_eca || "",
    marpol_garbage: data.marpol_garbage || "",
    marpol_noxious_liquid: data.marpol_noxious_liquid || "",
    marpol_oil: data.marpol_oil || "",
    marpol_sewage: data.marpol_sewage || "",
    portName: data.portName ?? null,
    port_name: data.port_name || "",
    position: {
        dec: {
          lat: data.position?.lat || null,
          lon: data.position?.lon || null,
        },
        Ddm: null,
        Dms: null,
      },
    position_id: data.position_id || "",
    sea_zone: data.sea_zone || "",
  };
}

export interface PositionAreaTimeline {
    position: PositionReport;
    spacial_area: SpacialArea;
}

export interface AreaTimeline {
  start: string;
  end: string;
  area_name: string;
  area_type: string;
  leg_hours: number | null;
  journey_perc: number | null;
}
export interface AreaSummary {
  area_name: string;
  total_hours: number | null;
  total_journey_perc: number | null;
}

function normaliseAreaType(area_type: any): string {
	if (typeof area_type !== "string") return "";
	return area_type.trim().toLowerCase();
}

export function formatAreaTimeline(data: any): AreaTimeline {
	return {
		start: data.start || "",
		end: data.end || "",
		area_name: data.area_name || "",
		area_type: normaliseAreaType(data.area_type),
		leg_hours: data.leg_hours || null,
		journey_perc: data.journey_perc || null,
	};
}

export interface AreaTotal {
  total_days: number;
  total_hours: number;
  total_minutes: number;
  area_name: string;
  area_type: string;
}

export function formatAreaTotal(data: any): AreaTotal {
	return {
		total_days: data.total_days || 0,
		total_hours: data.total_hours || 0,
		total_minutes: data.total_minutes || 0,
		area_name: data.area_name || "",
		area_type: normaliseAreaType(data.area_type),
	};
}
